<template>
  <div>
    <!-- <CardAlert color="#3E2723" class="mt-4 mx-4"
    
    > -->
    <v-toolbar dark :style="{ background: '#0277BD', color: 'white' }">
      <!-- <v-toolbar-title>å</v-toolbar-title> -->
      <v-autocomplete
        clearable
        dense
        v-model="selectedTransportation"
        :items="transportations"
        class="ml-4"
        flat
        hide-no-data
        hide-details
        :label="'Select ' + getCompanyLabels.transportations"
        solo-inverted
        @change="getSelectedTransportation()"
      ></v-autocomplete>
      <v-btn
        fab
        color="#01579B"
        small
        :class="isMobile ? 'mb-6 ml-2' : 'ml-2'"
        dark
        @click="openGlobalDialogSlot()"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- </CardAlert> -->

    <GlobalDialogSlot
      :title="title"
      :dialog="dialog"
      @close-dialog="dialog = false"
    >
      <CreateTransportation
        @transportation-created="getNewTransportation"
        @exist="title = 'Item Exist'"
      ></CreateTransportation>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import CreateTransportation from "./CreateTransportation.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";

export default {
  name: "Transport",
  components: { GlobalDialogSlot, CreateTransportation },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/get-all-transportations", this.getAccessToken)
      .then((transportations) => {
        transportations.forEach((transportation) => {
          this.transportations.push({
            text: `${transportation.name} [${transportation.id}]`,
            value: transportation,
          });
        });
        this.$store.commit("setLoader", false);
      });
  },
  data: () => ({
    title: "Create Transportation",
    transportations: [],
    selectedTransportation: null,
    dialog: false,
  }),
  methods: {
    getSelectedTransportation() {
      this.$emit("transportation-selected", this.selectedTransportation);
    },
    openGlobalDialogSlot() {
      this.dialog = true;
    },
    getNewTransportation(transportation) {
      this.transportations.push({
        text: `${transportation.name} [${transportation.id}]`,
        value: transportation,
      });
      this.selectedTransportation = transportation;
      this.$emit("transportation-selected", this.selectedTransportation);
      this.dialog = false;
    },
  },
};
</script>

<style></style>
